import type { JSX } from 'react';

import useGoogleAdsQuotaToast from '@feathr/extender/hooks/useGoogleAdsQuotaToast';

/** Runs the Google Ads limit-reached check. A component so it can mount only for Google campaigns. */
function GoogleAdsQuotaToast(): JSX.Element | null {
  useGoogleAdsQuotaToast();

  return null;
}

export default GoogleAdsQuotaToast;
